import React from 'react';
import { EDU_ARTICLES, CITY_PAGES, BLOGS } from '../mock';

// Per-route SEO metadata (keyword-rich for search & AI assistants)
const MAP = {
  '/': {
    title: 'Best Rheumatologist in Noida & Ghaziabad',
    description: 'Srigyan Rheumatology Clinic offers expert care for arthritis, lupus and autoimmune diseases in Noida, Ghaziabad & Delhi NCR, led by UK-trained consultant Dr Puneet Srivastava.',
  },
  '/who-we-are': {
    title: 'About Dr Puneet Srivastava | UK-Trained Rheumatologist',
    description: 'Meet Dr Puneet Srivastava, a UK-trained consultant rheumatologist (MRCP Rheumatology) with NHS experience, now serving patients in Noida, Ghaziabad and Delhi NCR.',
  },
  '/disorders-we-treat': {
    title: 'Arthritis & Autoimmune Diseases We Treat',
    description: 'We treat rheumatoid arthritis, ankylosing spondylitis, lupus (SLE), psoriatic arthritis, Sjogren\u2019s, vasculitis, gout and more in Noida & Ghaziabad.',
  },
  '/biological-therapy': {
    title: 'Biologic Therapy for Autoimmune Arthritis',
    description: 'Modern biologic therapy (TNF, IL-17, IL-6 inhibitors, Rituximab) for rheumatoid arthritis, spondylitis and autoimmune disease, delivered under expert supervision in Delhi NCR.',
  },
  '/second-opinion': {
    title: 'Rheumatology Second Opinion in Delhi NCR',
    description: 'Get an expert, evidence-based second opinion on your rheumatology diagnosis and treatment from a UK-trained consultant. Serving Noida, Ghaziabad & Delhi NCR.',
  },
  '/our-locations': {
    title: 'Our Locations | Rheumatology Clinic Ghaziabad & Noida',
    description: 'Visit Srigyan Rheumatology Clinic in Crossings Republik, Ghaziabad, or consult in Noida. Directions, hours and appointment details.',
  },
  '/video-gallery': {
    title: 'Rheumatology Patient Education Videos',
    description: 'Watch easy-to-understand videos on arthritis, autoimmune conditions and modern treatments from Srigyan Rheumatology Clinic.',
  },
  '/patient-education': {
    title: 'Patient Education | Arthritis & Autoimmune Guides',
    description: 'Clear, reliable guides on autoimmune disease, blood tests, joint care and diet from expert rheumatologists in Noida & Ghaziabad.',
  },
  '/ask': {
    title: 'Ask a Rheumatologist | Common Patient Questions',
    description: 'Answers to common questions: rheumatologist for lupus, vasculitis, joint pain, ankylosing spondylitis and more in Noida, Ghaziabad & Delhi NCR.',
  },
  '/blogs': {
    title: 'Rheumatology Blog | Insights & Health Tips',
    description: 'Expert articles on arthritis, autoimmune disease, treatment and healthy living from Srigyan Rheumatology Clinic.',
  },
  '/fellowship-program': {
    title: 'Rheumatology Fellowship Program',
    description: 'A structured rheumatology fellowship with hands-on clinical exposure, MSK ultrasound and UK-standard mentorship.',
  },
  '/login': { title: 'Staff Sign In', description: 'Authorised staff sign in for the Srigyan Rheumatology Clinic admin dashboard.' },
  '/contact': {
    title: 'Contact Us | Rheumatologist in Ghaziabad, Agra, Moradabad & Aligarh',
    description: 'Contact Srigyan Rheumatology Clinic: call +91 96257 10077, WhatsApp, email srigyanclinic@gmail.com or send a message. Clinic maps for Ghaziabad, Agra, Moradabad and Aligarh.',
  },
  '/international-patients': {
    title: 'International Patients | Online Rheumatologist Consultation from India (USA, UK, Australia, NZ, Gulf)',
    description: 'Online video consultation with UK-trained rheumatologist Dr Puneet Srivastava for patients in the USA, UK, Australia, New Zealand and Gulf countries. USD 40, report review, written plan for your local doctor, and help visiting India for treatment.',
  },
};

export function getSeo(pathname) {
  if (pathname.startsWith('/patient-education/')) {
    const slug = pathname.split('/').filter(Boolean).pop();
    const a = EDU_ARTICLES.find((x) => x.slug === slug);
    if (a) return { title: a.title, description: a.excerpt };
  }
  if (pathname.startsWith('/rheumatologist-in/')) {
    const key = pathname.split('/').filter(Boolean).pop();
    const c = CITY_PAGES[key];
    if (c) return {
      title: `Rheumatologist in ${c.city}`,
      description: `Consult Dr Puneet Srivastava, UK-trained consultant rheumatologist, in ${c.city} at ${c.clinic}. Expert care for arthritis, lupus, spondylitis and autoimmune diseases.`,
    };
  }
  if (pathname.startsWith('/blogs/')) {
    const id = pathname.split('/').filter(Boolean).pop();
    const b = BLOGS.find((x) => x.id === id);
    if (b) return { title: b.title, description: b.excerpt };
  }
  return MAP[pathname] || MAP['/'];
}

export default function Seo({ pathname }) {
  const { title, description } = getSeo(pathname);
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://rheumadoctor.com';
  const full = `${title} | Srigyan Rheumatology Clinic`;
  const noindex = pathname === '/login' || pathname === '/dashboard';
  return (
    <>
      <title>{full}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={description} />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={description} />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : <meta name="robots" content="index, follow" />}
      <link rel="canonical" href={origin + pathname} />
    </>
  );
}
